import { createContext, useContext, FC, ReactNode } from 'react';

export type PanelId = 'left' | 'right';

interface PanelContextType {
  panelId: PanelId | null;
}

const PanelContext = createContext<PanelContextType>({ panelId: null });

interface PanelProviderProps {
  panelId: PanelId | null;
  children: ReactNode;
}

export const PanelProvider: FC<PanelProviderProps> = ({ panelId, children }) => {
  return <PanelContext.Provider value={{ panelId }}>{children}</PanelContext.Provider>;
};

export const usePanelContext = () => {
  const context = useContext(PanelContext);
  return context.panelId;
};
